import React, { useCallback, useState } from 'react'

import { Button, Column, Input, Modal, Text } from 'Components/UI'

import { StagingAuth } from 'Services/Store/StagingAuth'

type Props = {
  isOpened?: boolean
}

function StagingAuthModal({ isOpened }: Props) {
  const [credentials, setCredentials] = useState<{
    login: string
    password: string
  }>({
    login: '',
    password: '',
  })

  const onClick = useCallback(() => {
    StagingAuth.set({
      login: credentials.login,
      password: credentials.password,
    })
  }, [credentials])

  return (
    <Modal
      closeButton={false}
      isOpen={isOpened}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
    >
      <Column p={[5, 5, 7, 7, 9]}>
        <Text mb={5} screen24>
          Sign in to Staging
        </Text>

        <Text mb={7} screen18>
          This environment requires login
        </Text>

        <Column gap={5} mb={7}>
          <Input
            label="Username"
            value={credentials.login}
            onChange={event =>
              setCredentials(prevState => ({
                login: event.target.value,
                password: prevState.password,
              }))
            }
          />

          <Input
            label="Password"
            value={credentials.password}
            onChange={event =>
              setCredentials(prevState => ({
                password: event.target.value,
                login: prevState.login,
              }))
            }
          />
        </Column>

        <Button
          disabled={!credentials.login || !credentials.password}
          onClick={onClick}
        >
          Sign in
        </Button>
      </Column>
    </Modal>
  )
}

export default StagingAuthModal
